import React, { useState, useRef } from "react";
import {
  Grid,
  TextField,
  Button,
  Typography,
  Box,
  Stack,
  Snackbar,
  Alert,
} from "@mui/material";
import { api, post } from "../../utils/api";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ResetPassword = ({ onBack, actionType = "create" }) => {
  console.log("actionType", actionType);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleSubmit = async () => {
    // if (!validateEmail(email)) {
    //   setError("Please enter a valid email address");
    //   return;
    // }
    console.log("submitinghb");

    try {
      const endpoint = `${api}/api/auth/forgot/password`;

      const response = await post(endpoint, { email });

      if (response?.error) {
        throw new Error(response.error || "Failed to process request");
      }

      // Handle success
      console.log("API call successful");
      setSnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });
      setSuccess(true);
      setError("");
    } catch (error) {
      setError(error.message || "Something went wrong");
      setSnackOpen({
        open: true,
        message: error.response.data.message || "Something went wrong",
        severity: "error",
      });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
      e.preventDefault();
    }
  };

  return (
    <>
      {success ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <CheckCircleIcon sx={{ fontSize: 60, color: "green", mb: 3 }} />{" "}
          {/* Check Icon */}
          <p className="main-heading">Email Sent Successfully</p>
          <p className="subheading">
            A reset link has been sent to your registered email. Please check
            your inbox.
          </p>
        </Box>
      ) : (
        <>
          <p className="main-heading">
            {" "}
            {actionType === "create" ? "Create Password" : "Reset Password"}
          </p>
          <p className="subheading">Please Use your Registered Email</p>

          {/* OTP Input Boxes */}
          <p className="input-label">Email ID</p>
          <TextField
            fullWidth
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => handleKeyDown(e)}
            placeholder="Email ID"
            variant="outlined"
            sx={{ mb: 1, marginTop: "-0.9rem" }}
            InputProps={{ sx: { height: "45px" } }}
          />

          {/* Forgot Password */}
          <Box
            sx={{
              display: "flex",
              alignItems: "right",
              justifyContent: "right",
              mb: 3,
            }}
          >
            <p className="last-label">Didn't get the Link?</p>
            <p className="last-label-bold" style={{ cursor: "pointer" }}>
              Resend Link
            </p>
          </Box>

          {/* Login Button */}
          <Button
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            sx={{
              bgcolor: "#EB7E0E",
              color: "#fff",
              textTransform: "none",
              py: 1.2,
              borderRadius: "10px",
              "&:hover": {
                bgcolor: "#EB7E0E",
              },
            }}
          >
            {/* Send Reset Link */}
            {actionType === "create" ? "Create Password" : "Send Reset Link"}
          </Button>

          <Snackbar
            open={snackOpen.open}
            message={snackOpen.message}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={() => setSnackOpen({ ...snackOpen, open: false })}
          >
            <Alert
              severity={snackOpen.severity}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {snackOpen.message}
            </Alert>
          </Snackbar>
        </>
      )}
    </>
  );
};

export default ResetPassword;
